import {Outlet} from "react-router-dom";
import {Box} from "@mui/material";

const VehiclePluginPage = () => {

    return (
        <Box>
            <Outlet />
        </Box>
    )
}

export default VehiclePluginPage